import { t } from '@lingui/core/macro';
import { AvatarList, UserAvatar } from '@pocketlaw/tetris';
import { DesktopTableBodyCell } from '../styled';
export function MembersCell(props) {
    const { members } = props;
    const deletedUser = t({
        message: 'Deleted user',
        comment: 'Fallback name when user does not exist',
    });
    return (<DesktopTableBodyCell headers="members">
      {members && (<AvatarList limit={5}>
          {members.map((member) => (<UserAvatar key={member.id} title={member.name || deletedUser}/>))}
        </AvatarList>)}
    </DesktopTableBodyCell>);
}
